module.exports = "/_next/static/images/pn-a7cc83d26c4a11c5a6207c66b040e934.svg";